import React, { useContext } from 'react';

import OrgLayoutContext from '@totem/components/orgManagement/layout/orgLayoutContext';
import BuildingsContainer from '@totem/components/orgManagement/orgDetails/buildings/applied/buildingsContainer';
import BuildingsTable from '@totem/components/orgManagement/orgDetails/buildings/applied/buildingsTable';
import OrgNetSuiteKeysContainer from '@totem/components/orgManagement/orgDetails/netSuiteKeys/applied/orgNetSuiteKeysContainer';
import OrgNetSuiteKeysTable from '@totem/components/orgManagement/orgDetails/netSuiteKeys/applied/orgNetSuiteKeysTable';
import XOrgUsersContainer from '@totem/components/orgManagement/orgDetails/users/applied/usersContainer';
import XOrgUsersTable from '@totem/components/orgManagement/orgDetails/users/applied/usersTable';
import { Organization } from '@totem/components/orgManagement/types';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';

const styles = {
  inset: {
    marginLeft: '40px',
    marginRight: '20px',
  },
};

type Props = {
  organization: Organization;
};

const OrgDetailsTabs = ({ organization }: Props) => {
  const { selectedDrawer, setDrawer } = useContext(OrgLayoutContext);

  return (
    <div style={styles.inset}>
      <IBTabs
        activeKey={selectedDrawer}
        onTabClick={(newKey) => setDrawer(newKey)}
        tabBarExtraContent={<div>{organization.name}</div>}
        items={[
          {
            key: 'netSuiteKeys',
            label: 'NetSuite Keys',
            children: (
              <OrgNetSuiteKeysContainer organization={organization}>
                <OrgNetSuiteKeysTable />
              </OrgNetSuiteKeysContainer>
            ),
          },
          {
            key: 'buildings',
            label: 'Buildings',
            children: (
              <BuildingsContainer organization={organization}>
                <BuildingsTable />
              </BuildingsContainer>
            ),
          },
          {
            key: 'users',
            label: 'Users',
            children: (
              <XOrgUsersContainer organization={organization}>
                <XOrgUsersTable />
              </XOrgUsersContainer>
            ),
          },
        ]}
      />
    </div>
  );
};

export default OrgDetailsTabs;
